import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { LocalStorageService } from "./local-storage.service";
import { Subject } from "rxjs/Subject";
import { Observable } from "rxjs/Observable";
import { BaseStorageService } from '../base.service';

@Injectable()
export class DataStorageService extends BaseStorageService {

  private headers: Headers;

  constructor(
    public localStorage: LocalStorageService) {
    super();
    this.headers = new Headers({
      'Content-Type': 'application/json'
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/storage/custom/data-storage.service.ts